/**
 * 戦闘の当事者。A が先に登録された側で、有利・不利の意味は持たない。
 */
export const BATTLE_SIDES = ['A', 'B'];
/** 勝敗。`DRAW` は規定ターン数に達しても決着しなかった場合。 */
export const BATTLE_OUTCOMES = ['A', 'B', 'DRAW'];
/**
 * 1 回の行動の種別。
 *
 * 演出側はこの文字列でアニメーションを分岐するため、**値の追加は演出の追加とセット**に
 * なる。増やすときは `apps/ios` の対応も同じ PR で行うこと。
 *
 * 回避された攻撃はこの列挙では表さず、**攻撃の action のまま `damage: 0`** で記録する。
 * 着弾すれば必ず 1 以上のダメージになる（エンジンの `MIN_DAMAGE`）ので、攻撃行動で
 * damage が 0 なら回避と一意に判別できる。詳細は `docs/specs/battle-log.md`。
 *
 * `REGENERATE` は攻撃ではないので常に `damage: 0` になる。**回避の判別を攻撃行動に
 * 限る**のはこのため。
 *
 * 「行動できなかった」を表す値は、状態異常（企画書 §9.1 系統「変」）を実装するときに
 * 追加する。生成側が存在しない値を契約に置くと、演出側が到達しない分岐を実装する
 * ことになるため、今は持たない。
 */
export const BATTLE_ACTIONS = ['NORMAL_ATTACK', 'SPECIAL_ATTACK', 'REGENERATE'];
/**
 * HP を減らす行動。回避の判別（`damage: 0`）が意味を持つのはこの行動のときだけ。
 *
 * `REGENERATE` は常に `damage: 0` なので、これで絞らないと「毎ラウンド回避している」
 * ように見える。演出側も同じ条件で分岐すること（`apps/ios`）。
 */
export const ATTACK_ACTIONS = ['NORMAL_ATTACK', 'SPECIAL_ATTACK'];
export const isAttackAction = (action) => ATTACK_ACTIONS.includes(action);
